import { Provider } from 'mobx-react';
import * as React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { modalStore } from 'ws-react-modal-dialog';
import { CookieAuthWrapperComponent, DynamicImport, NotFound } from 'ws-voice-infinity-global-module/lib/components';
import { authStore, eventStore, globalStore, mainPageStore, notificationStore, oktmoStore, userStore } from 'ws-voice-infinity-global-module/lib/store';
import ratingStore from '../modules/Evaluation/store/ratingStore';
import MainWrap from '../modules/Wrappers/mainWrap/mainWrapComponent';

const stores = { authStore, eventStore, globalStore, mainPageStore, modalStore, oktmoStore, userStore, ratingStore, notificationStore };

export default class MainRouter extends React.Component<{
    history?: any;
    location?: any;
}> {
    render() {
        return (
            <Provider
                {...stores}
            >
                <HashRouter>
                    <Switch>
                        <MainWrap
                            location={this.props.location}
                        >
                            <Switch>
                                <Route
                                    exact
                                    path="/"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Evaluation/pages/evaluationMain/evaluationMainContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/evaluation/:evaluationId"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Evaluation/pages/evaluationCard/evaluationCardContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/error/:errorCode"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Evaluation/pages/evaluationError/evaluationErrorContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/evaluation/:evaluationId/category/:participantCategoryId/create-vote-success"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Evaluation/pages/createVoteSuccess/createVoteSuccessContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/evaluation/:evaluationId/vote/list"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Evaluation/pages/evaluationVoteList/evaluationVoteListContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/cabinet/vote/list"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Evaluation/pages/myVoteList/myVoteListContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/evaluation/:evaluationId/participant/:participantId/vote"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Evaluation/pages/voteForm/voteFormContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/evaluation/:evaluationId/rating"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Evaluation/pages/evaluationRating/evaluationRatingContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/evaluation/:evaluationId/category/:categoryId/operational-rating"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Evaluation/pages/evaluationOperationalRating/evaluationOperationalRatingContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/evaluation/:evaluationId/category/:categoryId/rating/:year?/:period?"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Evaluation/pages/evaluationPeriodRating/evaluationPeriodRatingContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/evaluation/:evaluationId/participant/:participantId"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Evaluation/pages/participantCard/participantCardContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/evaluation/:evaluationId/participant/:participantId/rating-dynamic"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Evaluation/pages/participantRatingDynamic/participantRatingDynamicContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    component={NotFound}
                                />
                            </Switch>
                        </MainWrap>
                        <Route
                            component={NotFound}
                        />
                    </Switch>
                </HashRouter>
            </Provider>
        );
    }
}
